<template>
    <div class="card buildingCard">
        <div class="card-body buildingCard-body" v-bind:class="{'buildingCard-hasMap': hasGeo}">
            <div v-bind:class="{'buildingCard-infoMap': hasGeo}">
                <slot name="title"></slot>
                <dl class="card-text buildingCard-list buildingDetailsCard-list">
                    <form class="needs-validation" v-on:submit.prevent="createBuilding"
                          v-on:keydown="clear($event.target.name)"
                          novalidate>

                        <dt>
                            SP/DP:<sup>*</sup>
                        </dt>
                        <dd>
                            <input type="text" v-model="buildingInfo.strata_no" class="form-control"
                                   v-bind:class="{'is-invalid':response.errorMessage.strata_no}">
                            <div :class="{'invalid-feedback':response.errorMessage.strata_no}"
                                 v-if="response.errorMessage.strata_no">
                                Strata No Field is required
                            </div>
                        </dd>
                        <dt>
                            Building Name:
                        </dt>
                        <dd>
                            <input type="text" v-model="buildingInfo.name" class="form-control">
                        </dd>
                        <dt>
                            Building Address:<sup>*</sup>
                        </dt>
                        <dd>
                                <input type="text"
                                       class="form-control mb-2"
                                       placeholder="Enter a location"
                                       ref="googleMapInput"
                                       v-model="addressForGoogleMaps" v-if="showAddressFields">
                                <p v-if="showAddressFields" class="showAddressFields">
                                    Can't find your address?
                                    <a class="clickHere" href="javascript:void(0)" @click="showAddressFields = !showAddressFields">
                                        <u>
                                            Click here
                                        </u>
                                    </a> to enter manually
                                </p>
                                <p class="showAddressFields" v-else>
                                    <a class="clickHere" href="javascript:void(0)" @click="showAddressFields = !showAddressFields">
                                        <u>
                                            Click here
                                        </u>
                                    </a> to fill in building address with Google.
                                </p>
                        </dd>
                     <div v-if="!showAddressFields">
                        <dt>
                            Street Address:<sup>*</sup>
                        </dt>
                        <dd>
                            <input type="text" class="form-control" name="address" v-model="buildingInfo.address"
                                   v-bind:class="{'is-invalid':error.buildingInformation.address}">

                            <div :class="{'invalid-feedback':response.errorMessage.address}" v-if="response.errorMessage.address">
                                {{response.errorMessage.address[0]}}
                            </div>
                        </dd>
                        <dt>
                            Suburb:<sup>*</sup>
                        </dt>
                        <dd>
                            <input type="text" class="form-control" name="suburb" v-model="buildingInfo.suburb"
                                    v-bind:class="{'is-invalid':error.buildingInformation.suburb}">
                            <div :class="{'invalid-feedback':response.errorMessage.suburb}" v-if="response.errorMessage.suburb">
                                {{response.errorMessage.suburb[0]}}
                            </div>
                        </dd>
                        <dt>
                            Post Code:<sup>*</sup>
                        </dt>
                        <dd>
                            <input type="text" class="form-control" name="post_code" v-model="buildingInfo.post_code"
                                   v-bind:class="{'is-invalid':error.buildingInformation.postCode}">

                            <div :class="{'invalid-feedback':response.errorMessage.post_code}" v-if="response.errorMessage.post_code">
                                {{response.errorMessage.post_code[0]}}
                            </div>
                        </dd>
                        <dt>
                            State:<sup>*</sup>
                        </dt>
                        <dd>
                            <select class="form-control mb-3"
                                    v-model="buildingInfo.state"
                                    v-bind:class="{ 'is-invalid': error.buildingInformation.state }">
                                <option selected disabled value="">Choose...</option>
                                <option v-for="state in ['NSW', 'QLD', 'SA', 'TAS', 'VIC', 'WA', 'ACT', 'NT', 'SINGAPORE']" :value="state">{{state}}</option>
                            </select>

                            <div :class="{'invalid-feedback':response.errorMessage.state}" v-if="response.errorMessage.state">
                                {{response.errorMessage.state[0]}}
                            </div>
                        </dd>
                     </div>
                        <span class="mt-2">
                            <dt>Access Information:</dt>
                            <dd>
                           <textarea class="form-control" id="keyInformation" name="key"
                                     v-model="buildingInfo.key"
                           ></textarea>
                            </dd>
                        </span>
                        <dt>
                            Notes:
                        </dt>
                        <dd>
                           <textarea class="form-control mb-3" id="Note" placeholder="Note"
                                     v-model="buildingInfo.note">
                           </textarea>
                        </dd>
                        <div class="cancelButton float-left" v-if="isRequestSent">
                            <button type="button" class="btn btn-link" @click="$emit('close')">Cancel</button>
                        </div>

                        <div class="updateButton float-right">
                            <button class="btn btn-primary btn-success float-right" type="submit">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                                Update
                            </button>
                        </div>
                    </form>
                </dl>
            </div>
            <div class="google-map" ref="googleMap" v-bind:class="{'buildingCard-map': google}"></div>
        </div>

    </div>
</template>

<script>
  import GoogleMapsApiLoader from 'google-maps-api-loader'
  import ConnectionService from '../../app-model/model'
  import Building from '@/app-model/building.js';

  const connectionService = new ConnectionService()

  export default {
    props: {
      buildingId: Number,
      buildingLatitude: String | Number,
      buildingLongitude: String | Number,
      buildingStrataNo: String,
      buildingName: String,
      buildingAddress: String,
      buildingStatusColor: String,
      buildingSuburb:String,
      building_post_code:[Number,String],
      buildingState:String,
      buildingStreetAddress: String
    },
    data () {
      return {
        addressForGoogleMaps:this.buildingAddress,
        buildingInfo: {
          latitude: this.buildingLatitude,
          longitude: this.buildingLongitude,
          strata_no: this.buildingStrataNo,
          name: this.buildingName,
          address: this.buildingStreetAddress ,
          suburb:this.buildingSuburb,
          post_code:this.building_post_code,
          state:this.buildingState,
          key: undefined,
          parking: undefined,
          toilet: undefined,
          note: undefined,
        },
        id: this.buildingId,
        isRequestSent:true,
        googleLocationInput: '',
        google: null,
        map: null,
        showAddressFields:true,
        mapInitialized: false,
        loading:false,
        response: {
          isSuccess: false,
          isFailed: false,
          message: '',
          errorMessage: ''
        },
        error: {
          buildingInformation: []
        }
      }
    },
    created () {
      (async() => {
        let response = await this.$store.dispatch('apiResult', {
          method: 'GET',
          path: `api/user-buildings/${this.id}/building_key`,
          path_template: '/api/user-buildings/{building_id}/building_key',
          building_id: this.id
        });
        this.buildingInfo.key = response.data.data.key
      })();

      (async() => {
        await this.$store.dispatch('apiResult', {
          method: 'GET',
          path: `api/user-buildings/${this.id}/building_parking`,
          path_template: '/api/user-buildings/{building_id}/building_parking',
          building_id: this.id
        }).then(response => {
          this.buildingInfo.parking = response.data.data.parking
        });
      })();

      (async() => {
        let response = await this.$store.dispatch('apiResult', {
          method: 'GET',
          path: `api/user-buildings/${this.id}/building_toilet`,
          path_template: '/api/user-buildings/{building_id}/building_toilet',
          building_id: this.id
        })
        this.buildingInfo.toilet = response.data.data.toilet
      })();

      (async() => {
        let response = await this.$store.dispatch('apiResult', {
          method: 'GET',
          path: `api/user-buildings/${this.id}/building_note`,
          path_template: '/api/user-buildings/{building_id}/building_note',
          building_id: this.id
        });
        this.buildingInfo.note = response.data.data.note
      })();

      this.loadGoogleMaps()
    },
    computed: {
      hasGeo: function () {
        return (this.buildingLatitude && this.buildingLongitude) || this.buildingAddress
      },
      buildingModel: function () {
        return new Building;
      },
    },
    methods: {
      prefillData: function (place) {
        let latitude, longitude, addressForGoogleMaps ,address, suburb, post_code, state

        if (place.name) {
          address = place.name
        }

        if (place.address_components) {
          for (let i in place.address_components) {
            let location = place.address_components[i]
            switch (true) {
              case location.types.indexOf('locality') > -1 && location.types.indexOf('political') > -1:
                suburb = location.short_name
                break
              case location.types.indexOf('administrative_area_level_1') > -1 && location.types.indexOf('political') > -1:
                state = location.short_name
                break
              case location.types.indexOf('postal_code') > -1:
                post_code = location.short_name
                break
            }
          }
        }

        if (place.geometry) {
          latitude = place.geometry.location.lat()
          longitude = place.geometry.location.lng()
        }

        Object.assign(this.buildingInfo, {
          latitude,
          longitude,
          address,
          suburb,
          post_code,
          state,
        })
      },
      loadGoogleMaps: async function () {
        let latitude = -33.8688, longitude = 151.2195

        if (this.buildingInfo.latitude) {
          latitude = this.buildingInfo.latitude
        }

        if (this.buildingInfo.longitude) {
          longitude = this.buildingInfo.longitude
        }

        const googleMapApi = await GoogleMapsApiLoader({
          apiKey: window.GOOGLE_MAP_API_KEY,
          libraries: ['places']
        })
        this.google = googleMapApi
        this.map = new this.google.maps.Map(
          this.$refs.googleMap,
          {
            center: {
              lat: latitude,
              lng: longitude
            },
            zoom: 17,
            gestureHandling: 'cooperative'
          }
        )

        let top = this,
          autocomplete = new this.google.maps.places.Autocomplete(this.$refs.googleMapInput),
          marker = new this.google.maps.Marker({
            map: this.map,
            anchorPoint: new this.google.maps.Point(0, -29)
          }),
          map = this.map

        if (this.buildingInfo.latitude && this.buildingInfo.longitude) {
          marker.setPosition({
            lat: latitude,
            lng: longitude
          })
          marker.setVisible(true)
        }

        // Bind the map's bounds (viewport) property to the autocomplete object,
        // so that the autocomplete requests use the current map bounds for the
        // bounds option in the request.
        autocomplete.bindTo('bounds', this.map)

        // Set the data fields to return when the user selects a place.
        autocomplete.setFields(['address_components', 'geometry', 'icon', 'name'])

        autocomplete.addListener('place_changed', function () {
          marker.setVisible(false)
          let place = autocomplete.getPlace()

          if (!place.geometry) {
            // User entered the name of a Place that was not suggested and
            // pressed the Enter key, or the Place Details request failed.
            window.alert('No details available for input: \'' + place.name + '\'')
            return
          }

          // If the place has a geometry, then present it on a map.
          if (place.geometry.viewport) {
            map.fitBounds(place.geometry.viewport)
          } else {
            map.setCenter(place.geometry.location)
            map.setZoom(17)  // Why 17? Because it looks good.
          }
          marker.setPosition(place.geometry.location)
          marker.setVisible(true)

          top.prefillData(place)
        })
      },

      createBuilding: function () {
        this.loading = true
        this
          .$store
          .dispatch('apiResult',
            {
              method: 'PATCH',
              path: `api/v1/sites/${this.id}`,
              path_template: '/api/user-buildings/{building_id}',
              data: {
                latitude:  this.buildingInfo.latitude,
                longitude:  this.buildingInfo.longitude,
                strataNo:  this.buildingInfo.strata_no,
                name:  this.buildingInfo.name,
                address:  this.buildingInfo.address,
                suburb:  this.buildingInfo.suburb,
                postCode:  this.buildingInfo.post_code,
                state:  this.buildingInfo.state,
                key:  this.buildingInfo.key,
                parking: this.buildingInfo.parking,
                toilet: this.buildingInfo.toilet,
                note: this.buildingInfo.note,
              },
              building_id: this.id,
              section: 'fixture',
        })
          .then(response => {
          this.loading = false
          switch (response.status) {
            case 422:
              this.response.errorMessage = response.data
              this.error.buildingInformation = []
              for (let field in response.data) {
                this.error.buildingInformation[field] = true
              }
              break
            case 200:
              this.buildingInfo.strata_no = response.data.strataNo;
              this.buildingInfo.post_code = response.data.postCode;
              this.buildingModel.updateStoredBuilding ({store: this.$store}, this.id, this.buildingInfo);
              this.$emit('close')
              break
          }
        })
      },
      clear: function (field) {
        delete this.error.buildingInformation[field]
        delete this.response.errorMessage[field]
      },
    }
  }

</script>
<style lang="scss" scoped>
    @import "@/../sass/_building_card.scss";
</style>